<template>
  <div>
    <div class="p-4">
      <h2>Chat con DeepSeek</h2>

      <div class="border p-2 bg-light" style="height:200px; overflow-y:auto;">
        <pre>{{ response }}</pre>
      </div>

      <textarea v-model="userMessage" class="form-control mt-2" rows="3" placeholder="Escribe tu mensaje..."></textarea>
      
      <button @click="sendMessage" class="btn btn-primary mt-2" :disabled="loading">
        {{ loading ? "Cargando..." : "Enviar" }}
      </button>
    </div>    
    
  </div>
</template>


<script>
// import axios from "axios";
// import {mapMutations} from "vuex";
import baseApi from '@/services/baseApi';


export default {
  name: "ChatBot",    
  mounted() {
    // 1. Crear el elemento script
    // let script = document.createElement('script');
    
    // 2. Definir el código JS o la fuente (src)
    // script.innerHTML = "console.log('Script embebido ejecutado');";
    // Si es externo: 
    // script.src = "http://localhost:3000/solar-widget.js";
    // script.src = "http://localhost:3000/chat-widget.js";
    // script.setAttribute('data-client-id', 'cl_8627');
    
    // script.async = true;
    
    // 3. Añadir al DOM
    // document.body.appendChild(script);
  },
  data() {
    return {
      response: "",
      userMessage: "",
      loading: false,
      varme:true, //Creada por mi por que el WHILE no funcionaba
    };
  },
  methods: {
    async sendMessage2() {
      this.response = "";
      this.loading = true;

      const res = await fetch("https://www.cloudbits.org.mx/fw/lumen/check/deepseek-stream?message=" + encodeURIComponent(this.userMessage));
      const reader = res.body.getReader();
      const decoder = new TextDecoder();

     

      // while (true) {
      while (this.varme==true){
        // console.log('Activo')
        const { done, value } = await reader.read();
        if (done) break;
        this.response += decoder.decode(value);
      }

      this.loading = false;
    },
    async sendMessage() {
      this.response = "";
      this.loading = true;
      // let res=await axios.get("https://www.cloudbits.org.mx/fw/lumen/check/deepseek-stream?message=" + encodeURIComponent(this.userMessage))      
      // let res=await axios.get("https://www.cloudbits.org.mx/fw/lumen/check/")    
      let res= await baseApi().get("/deepseek-stream?message=" + encodeURIComponent(this.userMessage));
      alert (res.data);
      const reader = res.body.getReader();
      const decoder = new TextDecoder();

     

      // while (true) {
      while (this.varme==true){
        // console.log('Activo')
        const { done, value } = await reader.read();
        if (done) break;
        this.response += decoder.decode(value);
      }

      this.loading = false;
    },
    
  }
};
</script>
